import {DomainObject} from 'shared/store';
import { observable, makeObservable } from 'mobx';

class CompanyInsuranceCarrier extends DomainObject {
  name;
  company;
  upcomingRenewalDate;
  selfAssignedCertificatesEnabled;
  tpa;
  dataFeedEnabled;

  constructor(other) {
    super();

    makeObservable(this, {
      name: observable,
      company: observable,
      upcomingRenewalDate: observable,
      selfAssignedCertificatesEnabled: observable,
      tpa: observable,
      dataFeedEnabled: observable
    });

    this.merge(other);
  }
}

export default CompanyInsuranceCarrier;
